import types from './types';

import {promiseAction} from '~/misc/dispatch';
import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

const create = () => (dispatch, getState) => {
  if (getState().installation.id) {
    return Promise.resolve();
  }
  return promiseAction(dispatch, getState, types.INSTALLATION_CREATED,
    fetchWithState(getState, {
      url: '/tp/newinstallations',
      method: 'POST',
      body: {
        application: 'wc', 
        device: {
          platform: "wc",
        },
      },
    }).then(getFetchedJSON)
  );
};

const updateUser = () => (dispatch, getState) => {
  const inst = getState().installation;
  if (!inst.id || inst.isAssigned) {
    return Promise.resolve();
  }

  return promiseAction(dispatch, getState, types.INSTALLATION_USER_UPDATED,
    fetchWithState(getState, {
      url: `/tp/newinstallations/${inst.id}/user_id`,
      method: 'PUT',
    }, false)
  );
};

const remove = () => (dispatch, getState) => {
  const inst = getState().installation;
  if (!inst.id) {
    return Promise.resolve();
  }

  return promiseAction(dispatch, getState, types.INSTALLATION_REMOVED,
    fetchWithState(getState, {
      url: `/tp/newinstallations/${inst.id}`,
      method: 'DELETE',
    })
  );
};

export {
  create,
  updateUser,
  remove,
};



// WEBPACK FOOTER //
// ./src/modules/installation/actions.js